import { IncidentAttributeId } from '@collector/sportsapi-client-legacy'
import { ProbableIncident } from '@mobile/ActionQueue/Actions/Incidents/ProbableIncident'
import { IncidentDetailsFillState } from '@mobile/views/Relation/DetailsPanel/enums'

import { DetailConfiguration } from '../../../../composables/useSportOptions'
import { getIncidentAttributesDetailsFillState } from '../../../../Modals/utils'

export function getIncidentDetailsFillState<T extends IncidentAttributeId>(
  groups: Map<unknown, DetailConfiguration<T>>,
  incident: ProbableIncident,
): {
  state: IncidentDetailsFillState
} {
  if (!incident.attribute_ids) {
    return { state: IncidentDetailsFillState.NotFilled }
  }

  const state = getIncidentAttributesDetailsFillState(groups, incident)

  if (isPositionFilled(incident)) {
    if (state === IncidentDetailsFillState.NotFilled) {
      return { state: IncidentDetailsFillState.HalfFilled }
    }
    if (state === IncidentDetailsFillState.HalfFilled) {
      return { state: IncidentDetailsFillState.HalfFilled }
    }
    return { state }
  }

  if (state === IncidentDetailsFillState.NotFilled) {
    return { state: IncidentDetailsFillState.NotFilled }
  }

  return { state: IncidentDetailsFillState.HalfFilled }
}

function isPositionFilled(incident: ProbableIncident): boolean {
  return incident.x_pos !== null && incident.y_pos !== null
}
